import AnimatedPage from '../components/animatedPage'
import Banner from '../components/banner/banner'
import { DecodeHtml } from '../utils/decodeHtml'
import { retrunAssets, returnNotImage } from '../utils/getAssets'
import useFetch from '../utils/useFetch'

const StudentGuide = () => {
  const data = useFetch(
    'all-programmes/college-of-graduate-studies-cogs/cogs-student-guide/'
  )
  console.log(data)
  const studentGuide = data?.properties
  const title = studentGuide?.title
  const bg =
    studentGuide?.backgroundImage !== null
      ? retrunAssets(studentGuide?.backgroundImage[0]?.url)
      : returnNotImage()
  const topImageAndText =
    studentGuide?.imageAndRightRichText?.items != null
      ? studentGuide?.imageAndRightRichText?.items[0]?.content?.properties
      : null
  const belowImageAndText =
    studentGuide?.imagesAndBelowRichText?.items != null
      ? studentGuide?.imagesAndBelowRichText?.items[0]?.content?.properties
      : null
  return (
    <AnimatedPage>
      <Banner text={title} bg={bg} />
      <div className='flex justify-center flex-col gap-10 w-full p-8 md:p-12'>
        <div className='flex flex-col gap-3'>
          <h1 className='whitespace-pre-line heading'>
            {DecodeHtml({ html: studentGuide?.mainRichText?.markup })}
          </h1>
        </div>
        <div className='grid grid-cols-1 sm:grid-cols-3 whitespace-pre-line gap-5'>
          <img
            src={
              topImageAndText?.images !== null
                ? retrunAssets(topImageAndText?.images[0]?.url)
                : returnNotImage()
            }
            alt='image'
            className='object-cover max-w-full w-full h-[15rem]'
            
          />

          <div className='sm:col-span-2'>
            {DecodeHtml({ html: topImageAndText?.richText?.markup })}
          </div>
        </div>
        <div className='grid grid-cols-1 sm:grid-cols-2 whitespace-pre-line gap-5'>
          {belowImageAndText?.images !== null &&
            belowImageAndText?.images.map((image, index) => (
              <img
                key={index}
                src={retrunAssets(image?.url)}
                alt='image'
                className='object-cover max-w-full w-full h-[20rem]'
                
              />
            ))}
        </div>
        <div className='sm:col-span-3 whitespace-pre-line'>
          {DecodeHtml({ html: belowImageAndText?.richText?.markup })}
        </div>
      </div>
    </AnimatedPage>
  )
}

export default StudentGuide
